export default __webpack_public_path__ + "static/media/litho-demo-home-cafe.ec36e2c5.jpg";